import React               from 'react';
import { Router }               from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { confirmationModel }    from './ui/ConfirmationDialog';

function handleUserConfirmation(message: string, callback: (ok: boolean) => void) {
  confirmationModel.load(message, {
    yesAction: () => {
      callback(false);
      return true;
    },
    noAction: () => {
      callback(true);
      return true;
    },
    maxWidth: 'sm', title: 'Unsaved Changes'
  });
}

export const history = createBrowserHistory({ getUserConfirmation: handleUserConfirmation });

class RouterWithHistory extends React.PureComponent {
  render() {
    const {children, ...restProps} = this.props;
    return (
      <Router history={history} {...restProps}>
        {children}
      </Router>
    );
  }
}

export default RouterWithHistory;
